<template>
  <fragment>
      <tr>
        <td class="price-column-name">{{row_name}}</td>
        <td class="price-column-delete" v-for="tariff in tariffs">
            <button type="button" name="button"
              data-toggle="tooltip"
              data-placement="top"
              :title="tariff.id"
              :data-original-title="tariff.id"
              class="btn btn-danger btn-xs"
              @click="removeElement(tariff)">
                Usuń
            </button>
        </td>
      </tr>
  </fragment>
</template>

<script>
import $ from 'jquery';
import {Fragment} from 'vue-fragment';
import {mapActions} from 'vuex';

export default {
  data : function () {
    return {
      index_to_remove : 0,
    }
  },
  components : {
    Fragment
  },
  props : [
    'row_name',
    'tariffs',
    'route_tariff_destroy',
    'csrf_token'
  ],
  methods : {
    ...mapActions(['deleteTariff']),
    removeElement: function (tariff) {
      let self = this;
        this.$swal({
              title: self.__("delete_tariff?"),
              text: self.__("it_will_not_be_possible_to_retrieve_it_later_!"),
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: self.__("delete"),
              cancelButtonColor: "#D0D0D0",
              cancelButtonText: self.__("cancel"),
              closeOnConfirm: true,
              reverseButtons: true
          }).then(result => {
              if(result.value == true) {
                  let index = this.tariffs.indexOf(tariff);
                  this.deleteTariff(index)
              }
          })
    },
  },
  mounted : function () {
  }
}
</script>

<style lang="css" >
  .swal2-styled {
    padding:5px 15px !important;
  }
</style>
